import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'
import { Events } from '../core/events'
import { ExpandableElement } from '../modules/expandable-element.js'

import { ContentFilter } from '../modules/content-filter'
import debounce from 'lodash/debounce'
import { gsap } from 'gsap'

class ProgramFilter {
	constructor(options) {
		this.options = { ...options }

		this.element = this.options.element

		this.elToggle = this.element.querySelector('.js-program-filter-toggle')

		this.expandableElement = new ExpandableElement({
			element: this.element,
			toggleElement: this.elToggle,
			animationDuration: 0.2,
			ease: 'power2.inOut',
			wrapperSelector: '.program-filter__body',
			contentSelector: '.program-filter__body__content',
			measureMode: 'content',
			expandedClassTiming: 'immediate',
			cbOnChange: (state) => {
				// force reflow in safari
				// const content = this.element.querySelector(
				// 	'.expandable-element__content'
				// )
				// if (content) {
				// 	content.style.display = 'none'
				// 	content.offsetHeight // force reflow
				// 	content.style.display = ''
				// }

				if (state === 'expanded') {
					this.elToggle.classList.add('is-active')
				} else {
					this.elToggle.classList.remove('is-active')
				}
			},
			cbOnAfterChange: () => {
				EventBus.emit('page:resize')
			},
		})
	}
}

//
export default class extends Component {
	prepare() {}

	mount() {
		this.elGrid = this.element.querySelector('.js-content-grid-items')
		this.elFilters = this.element.querySelector('.js-content-filters')
		this.elFilterPanel = this.element.querySelector('.js-program-filter')
		// this.elParent = this.element.closest('.page-stories__content')

		// this.elFilters = this.elParent.querySelector('.js-stories-filters')
		// this.elGrid = this.elParent.querySelector('.js-stories-grid')

		if (this.elGrid) {
			this.contentFilter = new ContentFilter({
				elFilterContainer: this.elFilters,
				elContentContainer: this.elGrid,
				displayStyle: 'flex',
				filterLogicOptions: {
					history: true,
					allowMultiple: false,
					setQueryParams: true,
				},
				domHandlerOptions: {
					enableDomSorting: false, // Enable DOM reordering
					// enableLoadMore: true,
					// 	nrInitialVisibleItems: 999, // initial number of items visible
					// 	nrOfLoadItems: 6, // items to load per click
				},
			})
		}

		if (this.elFilters) {
			this.programFilter = new ProgramFilter({ element: this.elFilterPanel })
		}

		if (this.elGrid) {
			this.applyStagger()

			// Must stay synchronous: ContentFilter emits PAGE_RESIZE after setting
			// display but immediately before the items' fade-in tween starts, so
			// this is the one window to place the stagger before they reveal.
			// Debouncing it makes the offset visibly pop in mid-fade.
			this.onDomChange = () => this.applyStagger()
			EventBus.on(Events.PAGE_RESIZE, this.onDomChange)

			// Nothing emits PAGE_RESIZE on an actual viewport resize, so the
			// breakpoint change has to come from here. Debounced — unlike the
			// filter path, nothing is mid-animation.
			this.debouncedApplyStagger = debounce(() => this.applyStagger(), 100)
			this.resizeObserver = new ResizeObserver(this.debouncedApplyStagger)
			this.resizeObserver.observe(this.elGrid)
		}
	}

	// Offsets the middle column. Assigned per visible item rather than with
	// :nth-child, because the filter leaves hidden items in the DOM and
	// :nth-child would keep counting them.
	applyStagger() {
		const cols = getComputedStyle(this.elGrid).gridTemplateColumns.split(' ').length
		const staggerCol = cols >= 3 ? Math.floor(cols / 2) : cols === 2 ? 1 : -1

		let visibleIndex = 0

		for (const el of this.elGrid.children) {
			if (el.offsetParent === null) continue

			el.classList.toggle('is-staggered', visibleIndex % cols === staggerCol)
			visibleIndex++
		}
	}

	unmount() {
		if (this.resizeObserver) this.resizeObserver.disconnect()
		if (this.onDomChange) EventBus.off(Events.PAGE_RESIZE, this.onDomChange)
		if (this.debouncedApplyStagger) this.debouncedApplyStagger.cancel()
	}
}
